<i class="fas fa-users group-invite-header-icon"></i>
<h3 class="group-invite-title" transloco="groupInvite.dialog.header">
  Invite Members
</h3>
<h4 class="group-invite-description" transloco="groupInvite.dialog.description">
  By username or email.
</h4>

<div class="user-input-container">
  <ng-template ngFor
               let-i="index"
               let-user
               [ngForOf]="invitedUsers"
               [ngForTrackBy]="trackBy">
    <div class="invited-user-container">
      <i class="fas fa-trash-alt remove-invited-user-icon"
         aeroTooltip="{{ 'resume.delete' | transloco }}"
         *ngIf="!user.requestSent"
         (click)="deleteUser(i)">
      </i>

      <img class="remove-invited-user-icon"
           aeroTooltip="{{'groupInvite.dialog.failedInvite' | transloco}}"
           alt="remove invited user icon"
           *ngIf="user.requestSent && !user.createdSuccessfully"
           [src]="'resources/images/cancel_crop_icon.svg'"
      />

      <img class="successfully-invited-user-icon"
           aeroTooltip="{{'groupInvite.dialog.successfullyInvite' | transloco}}"
           alt="successfully invited user icon"
           *ngIf="user.requestSent && user.createdSuccessfully"
           [src]="'resources/images/confirm_crop_icon.svg'"
      />

      <input type="text"
             value="{{user.user}}"
             [ngClass]="{'invalid-input': user.requestSent && !user.createdSuccessfully}"
             [(ngModel)]="invitedUsers[i].user"
      />
      <div class="invalid-input-error-text"
           *ngIf="user.requestSent && !user.createdSuccessfully" transloco="groupInvite.dialog.invalidEntry">
        Invalid email or username.
      </div>
    </div>
  </ng-template>

  <div class="invited-user-container"
       *ngIf="!invitedUsers[0].requestSent">
    <img class="add-invited-user-icon"
         aeroTooltip="{{'resume.add.entry' | transloco}}"
         alt="add user icon"
         [src]="'resources/images/cancel_crop_icon.svg'"
         (click)="addUser()"
    />
    <input type="text"
           value=""
           disabled="true"
    />
  </div>
</div>

<div class="submit-button-container">
  <aero-button class="{{!invitedUsers[0].requestSent ? 'submit-button' : 'resubmit-button'}}"
               labelCode="{{!invitedUsers[0].requestSent ? 'submit' : 'resubmit'}}"
               (click)="submit()">
  </aero-button>
</div>
